import { Route } from 'react-router-dom'
import RaffleProcessPage from './pages/ProcessPage'

const routes = [
	<Route path={'/process'} element={<RaffleProcessPage />} key='process' />,
]

export default routes
